import { v4 as uuidv4 } from 'uuid';

export function ProductSpecification(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductSpecification',
		componentId: uuidv4(),
		props: Object.assign({}, props),
		childrenComponents,
	};
}
